import React from 'react'

export default function Spacer({ top=0, bottom=0 }){
    return <div style={{paddingTop:top, paddingBottom:bottom}} />
}